(function() {
  'use strict';

  angular.module('app.arcgisonline')
    .factory('agoSecurity', agoSecurity);

  function agoSecurity($rootScope, $q, esriRegistry, esriLoader) {
    let userData;
    let agoToken,
      agoUserId;
    let agoSecurityService = {
      initialize: initialize
    };

    return agoSecurityService;

    //////////// functions

    function initialize(data) {
      userData = angular.copy(data);
      agoToken = userData.agoToken;
      agoUserId = userData.agoUserId;
      let d = $q.defer();
      esriLoader.require([
        'esri/IdentityManager'
      ], function(
        esriId
      ) {
        let properties = {
          expires: new Date().getTime() + (1800 * 1000),
          server: 'https://www.arcgis.com',
          ssl: true,
          token: '',
          userId: ''
        };
        properties.token = agoToken;
        properties.userId = agoUserId;
        esriId.registerToken(properties);
        d.resolve({
          success: 'token registered'
        });
      });
      return d.promise;
    }

  }
}());